import React from 'react'

const GridColumns = ({ children }) => {
  return (
    <div className="grid-columns">
      {children}
    </div>
  )
}

export default GridColumns